import { ResponsiveBar } from "@nivo/bar";
import { randomIntFromInterval } from "../../../utils/random";
import { getColour, getColourPaletteHex } from "../../../utils/colours";

interface barData {
  [key: string]: string | number;
  label: string | number;
  value: number;
}

const dummyData = [
  {
    label: "1",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "2",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "3",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "4",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "5",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "6",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "7",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "8",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "9",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "10",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "11",
    value: randomIntFromInterval(1, 10),
  },
  {
    label: "12",
    value: randomIntFromInterval(1, 10),
  },
];

export default function VerticalBarChart({
  data,
  className,
  keys,
}: {
  data: barData[];
  className?: string;
  keys?: string[];
}) {
  const showPlaceholder = data.length === 0;
  return (
    <div className={className}>
      <ResponsiveBar
        data={showPlaceholder ? dummyData : data}
        keys={keys}
        indexBy="label"
        margin={{ top: 40, right: 25, bottom: 50, left: 40 }}
        padding={0.2}
        borderRadius={4}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={
          showPlaceholder
            ? getColour("placeholder")
            : [getColourPaletteHex("light-primary")]
        }
        enableLabel={false}
        motionConfig="wobbly"
        axisTop={null}
        axisRight={null}
        axisBottom={
          showPlaceholder
            ? null
            : {
                tickSize: 0,
                tickPadding: 10,
              }
        }
        axisLeft={
          showPlaceholder
            ? null
            : {
                tickSize: 0,
                tickPadding: 10,
                tickRotation: 0,
              }
        }
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{
          from: "color",
          modifiers: [["darker", 1.6]],
        }}
        isInteractive={!showPlaceholder}
        enableGridX={!showPlaceholder}
        enableGridY={!showPlaceholder}
      />
    </div>
  );
}

VerticalBarChart.defaultProps = {
  className: "",
  keys: ["value"],
};
